import createSetfilterPanelVar from './setFilterPanel';
import { filterPanelVar } from '../reactiveVariables';

const setFilterPanel = createSetfilterPanelVar(filterPanelVar);

export default setFilterPanel;
